export { default } from 'ember-cli-flash/flash/object';
